import StorageIcon from "@mui/icons-material/Storage";
import TableChartIcon from "@mui/icons-material/TableChart";
import HubIcon from "@mui/icons-material/Hub";
import BuildIcon from "@mui/icons-material/Build";

interface Props {
  name: string;
}

function ToolIcon({ name }: Props) {
  const sx = { fontSize: 18, color: "text.secondary" };
  if (name === "run_sql") return <StorageIcon sx={sx} />;
  if (name === "semantic_search") return <HubIcon sx={sx} />;
  if (name === "get_schema") return <TableChartIcon sx={sx} />;
  return <BuildIcon sx={sx} />;
}

export default ToolIcon;
